/* eslint-disable */

function guid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ window.crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}

var Guid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    guid: guid
});

export { Guid as G, guid as g };
//# sourceMappingURL=Guid-66109882.js.map
